import { render } from "./RuleWaitingListContent.vue?vue&type=template&id=54a1fd3e"
import script from "./RuleWaitingListContent.vue?vue&type=script&lang=js"
export * from "./RuleWaitingListContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleWaitingListContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54a1fd3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54a1fd3e', __exports__)) {
    api.reload('54a1fd3e', __exports__)
  }
  
  module.hot.accept("./RuleWaitingListContent.vue?vue&type=template&id=54a1fd3e", () => {
    api.rerender('54a1fd3e', render)
  })

}


export default __exports__